import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const MovieDetailPage = () => {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    fetch(`https://www.omdbapi.com/?i=${id}&apikey=${process.env.REACT_APP_OMDB_API_KEY}`)
      .then((res) => res.json())
      .then((data) => setMovie(data));
  }, [id]);

  if (!movie) {
    return <p style={{ textAlign: 'center' }}>Loading...</p>;
  }

  return (
    <div className="container">
      <div className="movie-detail">
        <img src={movie.Poster !== 'N/A' ? movie.Poster : 'https://via.placeholder.com/300x450'} alt={movie.Title} />
        <div className="movie-info">
          <h2>{movie.Title}</h2>
          <p><strong>Genre:</strong> {movie.Genre}</p>
          <p><strong>Language:</strong> {movie.Language}</p>
          <p><strong>Rating:</strong> {movie.imdbRating}</p>
          <div className="summary">
            <strong>Summary:</strong>
            <p>{movie.Plot}</p>
          </div>
        </div>
      </div>
      <Link className="back-link" to="/">← Back to Movie List</Link>
    </div>
  );
};


export default MovieDetailPage;